import {ApiService} from "./services/apiService";
import {UIService} from "./components/UIService";
import {PacketUIService} from "./components/packetComponent/packetUIService";
import {HandleUIService} from "./components/handleComponent/handleUIService";
import {AccessoryUIService} from "./components/accessoryComponent/accessoryUIService";
import {ConfiguratorHeaderUIService} from "./components/configuratorHeaderComponent/configuratorHeaderUIService";
import {AppStateService} from "./services/appStateService";
import {PriceService} from "./services/priceService";
import {GlazingPackageUIService} from "./components/glazingPackageComponent/glazingPackageUIService";
import {GlazingUIService} from "./components/glazingComponent/glazingUIService";
import {SerieUIService} from "./components/serieComponent/serieUIService";
import {MullionsUIService} from "./components/mullionsComponent/mullionsUIService";
import {ColorUIService} from "./components/colorComponent/colorUIService";
import {TypeUIService} from "./components/typeComponent/typeUIService";
import {MaterialUIService} from "./components/materialComponent/materialUIService";

import {PlisseSimpleSelectUIService} from "./components/plisseSimpleSelectComponent/plisseSimpleSelectUIService";
import {PlisseRailUIService} from "./components/plisseRailComponent/plisseRailUIService";
import {PlisseSheatingUIService} from "./components/plisseSheatingComponent/plisseSheatingUIService";

import {VerticalBlindSimpleSelectUIService} from "./components/verticalBlindSimpleSelectComponent/verticalBlindSimpleSelectUIService";
import {VerticalBlindTopRailUIService} from "./components/verticalBlindTopRailComponent/verticalBlindTopRailUIService";
import {VerticalBlindLouvreUIService} from "./components/verticalBlindLouvreComponent/verticalBlindLouvreUIService";

import {RollerBlindSimpleSelectUIService} from "./components/rollerBlindSimpleSelectComponent/rollerBlindSimpleSelectUIService";
import {RollerBlindFabricUIService} from "./components/rollerBlindFabricSelector/rollerBlindFabricUIService";
import {RollerBlindBoxUIService} from "./components/rollerBlindBoxSelector/rollerBlindBoxUIService";

import {InternalBlindSimpleSelectUIService} from "./components/internalBlindSimpleSelectComponent/internalBlindSimpleSelectUIService";
import {InternalBlindLouvreUIService} from "./components/internalBlindLouvreComponent/internalBlindLouvreUIService";
import {InternalBlindTopRailUIService} from "./components/internalBlindTopRailComponent/internalBlindTopRailUIService";

import {DrawingConfigurationService} from "./components/drawingComponent/drawingConfigurationService";
import {EventService} from "./services/eventService";
import {SvgService} from "./services/svgService";
import {AddToCartModalUIService} from "./components/addToCartModalComponent/addToCartModalUIService";
import Cookies from 'js-cookie';
import {DoorDrawingService} from "./services/doorDrawingService";
import {ProductDataStore} from "./stores/productDataStore";
import {ApiDataService} from "./services/apiDataService";

import cloneDeep from "lodash/cloneDeep";
import { HingeSideService } from "./services/hingeSideService";

export class App {
    public uiService: UIService;
    private svgService: SvgService;
    private productId?: string;
    private productConfigurationId?: string;
    private bundleId?: string;
    private orderProductId?: string;
    private productType?: string;
    private hiddenPrice?: boolean;
    private hiddenPriceOriginal?: boolean;
    private packetUIService: PacketUIService;
    private handleUIService: HandleUIService;
    private accessoryUIService: AccessoryUIService;
    private addToCartModalUIService: AddToCartModalUIService;
    private apiService: ApiService;
    private configuratorHeaderUIService: ConfiguratorHeaderUIService;
    private appStateService: AppStateService;
    private priceService: PriceService;
    private glazingUIService: GlazingUIService;
    private glazingPackagesUIService: GlazingPackageUIService;
    private serieUIService: SerieUIService;
    private typeUIService: TypeUIService;
    private materialUIService: MaterialUIService;
    private mullionsUIService: MullionsUIService;
    private colorUIService: ColorUIService;
    private productDataStore: ProductDataStore;
    private eventService: EventService;

    private plisseSimpleSelectUIService: PlisseSimpleSelectUIService;
    private plisseRailUIService: PlisseRailUIService;
    private plisseSheatingUIService: PlisseSheatingUIService;

    private verticalBlindSimpleSelectUIService: VerticalBlindSimpleSelectUIService;
    private verticalBlindTopRailUIService: VerticalBlindTopRailUIService;
    private verticalBlindLouvreUIService: VerticalBlindLouvreUIService;

    private rollerBlindSimpleSelectUIService: RollerBlindSimpleSelectUIService;
    private rollerBlindFabricUIService: RollerBlindFabricUIService;
    private rollerBlindBoxUIService: RollerBlindBoxUIService;

    private internalBlindSimpleSelectUIService: InternalBlindSimpleSelectUIService;
    private internalBlindLouvreUIService: InternalBlindLouvreUIService;
    private internalBlindTopRailUIService: InternalBlindTopRailUIService;

    private drawingService: DrawingConfigurationService;
    private doorDrawingService: DoorDrawingService;
    private apiDataService: ApiDataService;

    /*
    * Here we want only to bootstrap the application and get product data from the API
    * We'll initialize the rest of the application after we get product data which is needed to do that.
    * Do not add any other code here, otherwise You will end up with errors,
    * any other code should end up in the initializeApplication() method
    */
    constructor()
    {
        this.eventService = new EventService();
        this.uiService = new UIService();
        this.bootstrapApplication();
        this.apiService = new ApiService();
        this.appStateService = new AppStateService();
        this.doorDrawingService = new DoorDrawingService();
        this.appStateService.initializeAppState();

        if (this.hiddenPrice) {
            return;
        }
        this.getProductDataFromApi();

        // we want to initialize the app after we get the product data
        this.eventService.getTarget().addEventListener('productDataLoaded', (data) => {
            this.initializeApplication();
        });
        this.initializePrices();

        this.eventService.getTarget().addEventListener('reloadDrawing', (data) => {
            if (this.appStateService.getAppSettingOption('iccDrawing')) {
                this.uiService.updateDrawingComponent(new DrawingConfigurationService().getDrawingConfig());
            }
        });

        this.eventService.getTarget().addEventListener('reloadDoorDrawing', (data) => {
            // @todo: set a proper viewSide base on configuration
            const viewSide = 'outside';
            const viewSideKey = viewSide === 'outside' ? 'outer' : 'inner';
            const productData = this.appStateService.getProductDataStore();
            const color = productData.included.color.find(
                colorDetails => Number(colorDetails.id) === Number(productData.data[0].relationships[viewSideKey].data.id)
            );
            const hingeSide = productData.data[0].relationships.hingeSide ?
                productData.data[0].relationships.hingeSide.data.id :
                HingeSideService.LEFT_HINGE_ID;

            this.doorDrawingService.setHingeSide(hingeSide);
            this.doorDrawingService.setHeight(productData.data[0].attributes.height);
            this.doorDrawingService.setWidth(productData.data[0].attributes.width);
            this.doorDrawingService.setImage(viewSide, productData.data[0].attributes.visualization[viewSideKey]);
            this.doorDrawingService.setColorHex(viewSide, color.attributes.hex);
            this.doorDrawingService.update(viewSide);
        });
    }

    private initializeApplication()
    {
        this.productDataStore = new ProductDataStore();
        this.configuratorHeaderUIService = new ConfiguratorHeaderUIService();
        this.configuratorHeaderUIService.initializeConfiguratorHeader();
        this.priceService = new PriceService();

        this.initializeAddToCartModal();
        this.initializeAddToCartButton();
        this.initializeJumpToConfiguratorButton();

        if (this.productDataStore.getProductType() === 'door') {
            this.eventService.emit('reloadDoorDrawing');
        }

        if (this.appStateService.getAppSettingOption('iccDrawing')) {
            this.drawingService = new DrawingConfigurationService();
            this.uiService.updateDrawingComponent(this.drawingService.getDrawingConfig());
            this.initializeDrawingOptionsButtons();
        }
        this.replaceRelationshipFromLocalStorage();
        this.initializeProductComponents();
        this.priceService.recalculatePrice();

        const initialModule = (this.isDoorColorCookieSet()) ? 'colors' : null;
        this.uiService.initBasicBehaviours(initialModule);
    }

    private initializePrices()
    {
        const isB2Bcustomer = Cookies.get('b2b-homepage') === '1';
        const showRegularCustomerPrice = Cookies.get('display-end-customer-price') === '1';

        if (isB2Bcustomer) {
            this.appStateService.setAppSettingTemplateFlag('app', 'regularCustomerPrice', false);
            this.appStateService.setAppSettingTemplateFlag('app', 'b2bCustomerPrice', true);
        } else if (showRegularCustomerPrice) {
            this.appStateService.setAppSettingTemplateFlag('app', 'regularCustomerPrice', true);
            this.appStateService.setAppSettingTemplateFlag('app', 'b2bCustomerPrice', false);
        } else {
            this.appStateService.setAppSettingTemplateFlag('app', 'regularCustomerPrice', true);
            this.appStateService.setAppSettingTemplateFlag('app', 'b2bCustomerPrice', false);
        }
        this.uiService.refreshElementsInModule('app');
    }

    private addToCart(withRedirect = true, url)
    {
        this.apiDataService = new ApiDataService();
        const apiRequestObject = this.apiDataService.getDataForProductApiCall();
        this.apiService
            .addToCart(apiRequestObject)
            .then((response) => {
                let hasDoorsWithHandleInCart = false;
                let hasUniversalKeyEnabledInCart = false;

                response.data.forEach((cartProduct) => {
                    if (cartProduct.type === 'door') {
                        if (cartProduct.has_handle) {
                            hasDoorsWithHandleInCart = true;
                        }
                        if (cartProduct.universal_key_included) {
                            hasUniversalKeyEnabledInCart = true;
                        }
                    }
                });
                if (hasDoorsWithHandleInCart) {
                    // @todo: show universal key in configurator
                }
                if (hasUniversalKeyEnabledInCart) {
                    // @todo: enable universal key in configurator
                }
                if (withRedirect) {
                    window.location.href = url;
                } else {
                    // jQuery method from product configure page scope
                    // @ts-ignore
                    loadCart();
                }
            });
    }

    private updateProductInTheCart(url)
    {
        this.apiDataService = new ApiDataService();
        const data = this.apiDataService.getDataForProductApiCall();
        this.apiService
            .addToCart(data)
            .then(() => {
                window.location.href = url;
            });
    }

    private updateProductInTheOffer()
    {
        this.apiDataService = new ApiDataService();
        const data = this.apiDataService.getDataForProductApiCall();
        this.apiService
            .updateProductInTheOffer(data)
            .then((response) => {
                const offerId = response.data['0'].order_id;
                const requestStatus = response.meta.success;

                if (requestStatus) {
                    window.location.href = (response.data['0'].isSalesman) ? `/shop/offers/employee-summary/${offerId}` : `/shop/offers/summary/${offerId}`;
                }
            });
    }

    private initializeJumpToConfiguratorButton()
    {
        const buttons = this.uiService.getElementByActionName('jumpToConfigurator');

        buttons.forEach((element) => {
            element.addEventListener('click', (event: any) => {
                document.getElementById('app').scrollIntoView({
                    behavior: 'smooth'
               });
            });
        });
    }

    private initializeAddToCartButton()
    {
        const addToCartButtons = this.uiService.getElementByActionName('addToCart');
        const updateProductInTheCartButtons = this.uiService.getElementByActionName('updateProductInCart');
        const updateProductInTheOfferButtons = this.uiService.getElementByActionName('updateProductInOffer');
        const cancelAddToCartActionButtons = this.uiService.getElementByActionName('cancelAddToCart');

        addToCartButtons.forEach((element) => {
            element.addEventListener('click', (event: any) => {
                const redirect = event.currentTarget.getAttribute('nf-redirect');
                const url = event.currentTarget.getAttribute('nf-url');
                this.addToCart(redirect === 'true', url);
                this.appStateService.setAppSettingTemplateFlag('app', 'showAccessoriesReminderModal', false);
                this.uiService.refreshElementsInModule('app');
            });
        });
        updateProductInTheCartButtons.forEach((element) => {
            element.addEventListener('click', (event: any) => {
                const url = event.currentTarget.getAttribute('nf-url');
                this.updateProductInTheCart(url);
                this.appStateService.setAppSettingTemplateFlag('app', 'showAccessoriesReminderModal', false);
                this.uiService.refreshElementsInModule('app');
            });
        });
        updateProductInTheOfferButtons.forEach((element) => {
            element.addEventListener('click', (event: any) => {
                this.updateProductInTheOffer();
                this.appStateService.setAppSettingTemplateFlag('app', 'showAccessoriesReminderModal', false);
                this.uiService.refreshElementsInModule('app');
            });
        });

        cancelAddToCartActionButtons.forEach((element) => {
            element.addEventListener('click', () => {
                this.appStateService.setAppSettingTemplateFlag('app', 'showAccessoriesReminderModal', false);
                this.uiService.refreshElementsInModule('app');
            });
        });
    }

    private initializeAddToCartModal()
    {
        const addToCartButtons = this.uiService.getElementByActionName('openRecommendedAccessoriesModal');
        this.appStateService.setAppSettingTemplateFlag('app', 'showAccessoriesReminderModal', false);

        addToCartButtons.forEach(addToCartButton => {
            addToCartButton.addEventListener('click', (event: any) => {
                // if (this.appStateService.getProductDataStore().included.accessory.length > 0) {
                //     this.appStateService.setAppSettingTemplateFlag('app', 'showAccessoriesReminderModal', true);
                //     this.uiService.refreshElementsInModule('app');
                // } else {
                //     this.addToCart();
                // }
                this.appStateService.setAppSettingTemplateFlag('app', 'showAccessoriesReminderModal', true);
                this.uiService.refreshElementsInModule('app');
            });
        });
        this.uiService.refreshElementsInModule('app');
    }

    private bootstrapApplication()
    {
        const app = this.uiService.getElementById('app');

        if (app === null) {
            throw new Error("Sorry, there is no application element in the HTML structure");
        }
        this.productId = app.getAttribute('productid');
        this.productConfigurationId = app.getAttribute('confid');
        this.bundleId = app.getAttribute('bundleid');
        this.orderProductId = app.getAttribute('orderproductid');
        this.productType = app.getAttribute('producttype');
        this.hiddenPrice = !!app.getAttribute('hiddenprice');
        this.hiddenPriceOriginal = !!app.getAttribute('hiddenpriceoriginal');

        if (this.productId === '' || this.productConfigurationId === '' || this.productId === null || this.productConfigurationId === null) {
            throw new Error("Sorry, there is no product or configuration id");
        }
    }

    private getProductDataFromApi()
    {
        this.apiService.getProduct(this.productId, this.productConfigurationId, this.orderProductId, this.bundleId).then((productData) => {
            this.appStateService.validate(productData);
            this.appStateService.setInitialState(productData);
            this.appStateService.setState(productData);
            this.appStateService.setAppSettingOption('isMobile', productData.configuratorSettings.isMobile)
            this.appStateService.setAppSettingOption('activeComponents', productData.configuratorSettings.activeComponents)
            this.appStateService.setAppSettingOption('iccDrawing', productData.configuratorSettings.iccDrawing)
            this.appStateService.setAppSettingOption('isSalesman', productData.configuratorSettings.isSalesman)
            this.appStateService.setAppSettingOption('allowToMoveMullions', productData.configuratorSettings.allowToMoveMullions)

            this.eventService.emit('productDataLoaded');
        });
    }

    private initializeDrawingOptionsButtons()
    {
        const buttonInside = this.uiService.getElementByClassName('configurator__buttonInside');
        const buttonOutside = this.uiService.getElementByClassName('configurator__buttonOutside');
        const isDefaultOutsideView = !this.productDataStore.getAttributeByName('defaultInsideView');

        if (isDefaultOutsideView) {
            buttonOutside.classList.add('--active');
        } else {
            buttonInside.classList.add('--active');
        }

        buttonInside.addEventListener('click', event => {
            buttonInside.classList.add('--active');
            buttonOutside.classList.remove('--active');
            if (this.appStateService.getAppSettingOption('iccDrawing')) {
                this.uiService.updateDrawingSide('inner');
                this.uiService.updateDrawingComponent(this.drawingService.getDrawingConfig());
            }
        })
        buttonOutside.addEventListener('click', event => {
            buttonInside.classList.remove('--active');
            buttonOutside.classList.add('--active');
            if (this.appStateService.getAppSettingOption('iccDrawing')) {
                this.uiService.updateDrawingSide('outer');
                this.uiService.updateDrawingComponent(this.drawingService.getDrawingConfig());
            }
        })
    }

    private initializeProductComponents()
    {
        const activeComponents = this.appStateService.getAppSettingOption('activeComponents');

        if (activeComponents.includes('series') && !this.uiService.isInEditMode()) {
            this.serieUIService = new SerieUIService();
            this.serieUIService.initializeSeriesComponent();
        }

        if (activeComponents.includes('types')) {
            this.typeUIService = new TypeUIService();
            this.typeUIService.initializeComponent();
        }

        if (activeComponents.includes('materials')) {
            this.materialUIService = new MaterialUIService();
            this.materialUIService.initializeComponent();
        }

        if (activeComponents.includes('glazingPackages')) {
            this.glazingPackagesUIService = new GlazingPackageUIService();
            this.glazingPackagesUIService.initializeGlazingPackageComponent();
        }

        if (activeComponents.includes('glazing')) {
            this.glazingUIService = new GlazingUIService();
            this.glazingUIService.initializeGlazingComponent();
        }

        if (activeComponents.includes('packets')) {
            this.packetUIService = new PacketUIService();
            this.packetUIService.initializePacketComponent();
        }

        if (activeComponents.includes('handles')) {
            this.handleUIService = new HandleUIService();
            this.handleUIService.initializeHandleComponent();
        }

        if (activeComponents.includes('accessories')) {
            this.accessoryUIService = new AccessoryUIService();
            this.accessoryUIService.initialize();
        }

        if (activeComponents.includes('mullions')) {
            this.mullionsUIService = new MullionsUIService();
            this.mullionsUIService.initializeMullionsSelector();
        }

        if (activeComponents.includes('colors')) {
            this.colorUIService = new ColorUIService();
            this.colorUIService.initializeColorComponent();
        }

        if (activeComponents.includes('plisseMontageTypes')) {
            this.plisseSimpleSelectUIService = new PlisseSimpleSelectUIService();
            this.plisseSimpleSelectUIService.initializePlisseMontageTypeSelector();
        }

        if (activeComponents.includes('plisseDrives')) {
            this.plisseSimpleSelectUIService = new PlisseSimpleSelectUIService();
            this.plisseSimpleSelectUIService.initializePlisseDriveSelector();
        }

        if (activeComponents.includes('plisseRails')) {
            this.plisseRailUIService = new PlisseRailUIService();
            this.plisseRailUIService.initializePlisseRailSelector();
        }

        if (activeComponents.includes('plisseSheatings')) {
            this.plisseSheatingUIService = new PlisseSheatingUIService();
            this.plisseSheatingUIService.initializePlisseSheatingSelector();
        }

        if ([
            'verticalBlindControlSides',
            'verticalBlindChains',
            'verticalBlindStackingTypes',
            'verticalBlindMontageTypes',
            'verticalBlindTopRails',
            'verticalBlindLouvres',
        ].some(component => activeComponents.includes(component))) {
            this.verticalBlindSimpleSelectUIService = new VerticalBlindSimpleSelectUIService();
            this.verticalBlindTopRailUIService = new VerticalBlindTopRailUIService();
            this.verticalBlindLouvreUIService = new VerticalBlindLouvreUIService();

            this.verticalBlindSimpleSelectUIService.initializeVerticalBlindChainsSelector();
            this.verticalBlindSimpleSelectUIService.initializeVerticalBlindControlSideSelector();
            this.verticalBlindSimpleSelectUIService.initializeVerticalBlindStackingTypeSelector();
            this.verticalBlindSimpleSelectUIService.initializeVerticalBlindMontageTypeSelector();
            this.verticalBlindTopRailUIService.initializeVerticalBlindTopRailSelector();
            this.verticalBlindLouvreUIService.initializeVerticalBlindLouvreSelector();
        }

        if ([
            'rollerBlindBoxes',
            'rollerBlindFabrics',
            'rollerBlindControlSides',
        ].some(component => activeComponents.includes(component))) {
            this.rollerBlindBoxUIService = new RollerBlindBoxUIService();
            this.rollerBlindFabricUIService = new RollerBlindFabricUIService();
            this.rollerBlindSimpleSelectUIService = new RollerBlindSimpleSelectUIService();

            this.rollerBlindBoxUIService.initializeRollerBlindBoxSelector();
            this.rollerBlindFabricUIService.initializeRollerBlindFabricSelector();
            this.rollerBlindSimpleSelectUIService.initializeRollerBlindControlSideSelector();
        }

        if ([
            'internalBlindControlSides',
            'internalBlindTopRails',
            'internalBlindLouvres',
            'internalBlindBottomRails',
        ].some(component => activeComponents.includes(component))) {
            this.internalBlindSimpleSelectUIService = new InternalBlindSimpleSelectUIService();
            this.internalBlindTopRailUIService = new InternalBlindTopRailUIService();
            this.internalBlindLouvreUIService = new InternalBlindLouvreUIService();

            this.internalBlindSimpleSelectUIService.initializeInternalBlindControlSideSelector();
            this.internalBlindSimpleSelectUIService.initializeInternalBlindBottomRailSelector();
            this.internalBlindTopRailUIService.initializeInternalBlindTopRailSelector();
            this.internalBlindLouvreUIService.initializeInternalBlindLouvreSelector();
        }

        if (activeComponents.includes('verticalBlindChains')) {

        }

        if (['accessories', 'packets'].some(component => activeComponents.includes(component))) {
            this.addToCartModalUIService = new AddToCartModalUIService();
            this.addToCartModalUIService.initialize();
        }
    }

    /** If the cookie is set, we want to display color component first */
    private isDoorColorCookieSet(): boolean
    {
        let configurationId = this.productDataStore.getData().data[0]['configurationId'];
        let cookieData = Cookies.get(`default_config_color_${configurationId}`);

        Cookies.remove(`default_config_color_${configurationId}`, {
            path: '/',
            sameSite: 'Lax',
            secure: true,
        });

        return cookieData;
    }

    private replaceRelationshipFromLocalStorage()
    {
        const keysToReplace = {
            accessories: {
                availablesKey: 'accessory'
            },
            insideGlass: {
                availablesKey: 'glass',
                filterAvailableList: function(elem) {
                    return elem.attributes.canBeInside;
                }
            },
            outsideGlass: {
                availablesKey: 'glass',
                filterAvailableList: function(elem) {
                    return elem.attributes.canBeOutside;
                }
            },
            ornament: {
                availablesKey: 'ornament'
            },
            glazingSpacers: {
                availablesKey: 'glazingSpacers'
            },
            handleInside: {
                availablesKey: 'handle',
                filterAvailableList: function(elem) {
                    return elem.attributes.can_be_inside;
                }
            },
            handleOutside: {
                availablesKey: 'handle',
                filterAvailableList: function(elem) {
                    return elem.attributes.can_be_outside;
                }
            },
            predefinedMullionLayout: {
                availablesKey: 'predefinedMullionLayout'
            },
            inner: {
                availablesKey: 'color',
            },
            outer: {
                availablesKey: 'color',
            }
        };
        const localStorageRelationship = JSON.parse(localStorage.getItem('relationship')) ?? null;
        localStorage.removeItem('relationship');

        if (localStorageRelationship !== null) {
            for (const keyToReplace in keysToReplace) {
                if (localStorageRelationship[keyToReplace] !== undefined && localStorageRelationship[keyToReplace].data !== undefined) {
                    if (Array.isArray(localStorageRelationship[keyToReplace].data)) {
                        let newData = [];
                        for (let data of localStorageRelationship[keyToReplace].data) {
                            if (
                                data.id !== undefined && data.id !== null &&
                                this.productDataStore.getAvailableOptionByNameAndId(
                                    keysToReplace[keyToReplace].availablesKey,
                                    data.id,
                                    keysToReplace[keyToReplace].filterAvailableList
                                ) !== null
                            ) {
                                newData.push(data);
                            }
                        }
                        if (newData.length > 0) {
                            let selectedOptions = cloneDeep(newData);
                            this.productDataStore.updateSelectedOption(keyToReplace, selectedOptions);
                        }
                    } else {
                        let data = localStorageRelationship[keyToReplace].data;
                        if (
                            data.id !== undefined && data.id !== null &&
                            this.productDataStore.getAvailableOptionByNameAndId(
                                keysToReplace[keyToReplace].availablesKey,
                                data.id,
                                keysToReplace[keyToReplace].filterAvailableList
                            ) !== null
                        ) {
                            this.productDataStore.updateSelectedOption(keyToReplace, data.id);
                        }
                    }
                }
            }
        }
    }
}
